import { ContentNotificationsEndpoint as ContentNotificationsEndpointInterface } from '@apiClient/interfaces/endpoints/ContentNotifications.endpoint';
import ContentNotificationsSearchDto from '@apiClient/interfaces/request/content/NotificationsSearch.dto';
import ContentNotificationDto, { NotificationTemplate } from '@apiClient/interfaces/models/content/Notification.dto';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import PaginationDto from '@/projectRoot/api-client/interfaces/request/Pagination.dto';
import NotificationsSearchByTemplateDto from '@/projectRoot/api-client/interfaces/request/content/NotificationsSearchByTemplate.dto';

export class ContentNotificationsEndpoint implements ContentNotificationsEndpointInterface {
    
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * /api/content/notifications
    */
    async search(params?: ContentNotificationsSearchDto): Promise<ApiResponseDto<ContentNotificationDto[], PaginationDto>> {
        return this._httpClient
            .get(`content/notifications`, { searchParams: buildSearchParams(params), cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    /**
    * /api/content/notifications/{id}
    */
    async single(id: string): Promise<ApiResponseDto<ContentNotificationDto, undefined>> {
        return this._httpClient
            .get(`content/notifications/${id}`, { cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }

    /**
     * /api/content/notifications/by-template
     */
    async searchByTemplate(params: NotificationsSearchByTemplateDto): Promise<ApiResponseDto<ContentNotificationDto[], PaginationDto>> {
        return this._httpClient
            .get(`content/notifications/by-template`, { searchParams: buildSearchParams({ template: params.template }), cache: this.cache })
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
}

export default ContentNotificationsEndpoint;